import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { filesActionCreators } from '..';
import { uiActionCreators } from '../../ui';
import * as api from '../filesApi';

function* fetchSalesDocumentsSaga(action: ReturnType<typeof filesActionCreators.fetchSalesDocuments>) {
  const { hideSpinner, prefix } = action.payload;
  if (!hideSpinner) {
    yield put(uiActionCreators.toggleLoading('salesDocuments'));
  }
  try {
    const response = yield* call(api.fetchSalesDocument, prefix);

    yield put(filesActionCreators.setFiles(response));
    yield put(filesActionCreators.setSalesDocuments(response));
  } catch {
    //
  }

  if (!hideSpinner) {
    yield put(uiActionCreators.toggleLoading('salesDocuments'));
  }
}

export function* watchFetchSalesDocuments() {
  yield takeEvery(filesActionCreators.fetchSalesDocuments.match, fetchSalesDocumentsSaga);
}
